import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import { formatDateTitle } from '../../../utils';
import { BackButton } from '../BackButton';
import { NextButton } from '../NextButton';

import { DateWrapper } from './Info.styles';

import { usePlanificationTimeline } from '@/hooks/usePlanificationTimeline';

export const Info: React.FC = () => {
  const { t } = useTranslation('StudentDashboardTranslations');

  const { selectedDate, planificationDates, handlePrev, handleNext, currentSlide } =
    usePlanificationTimeline();

  return (
    <>
      <Flex gap={16} justify="space-between" align="center">
        <DateWrapper>{formatDateTitle(selectedDate, t)}</DateWrapper>

        <div>
          <BackButton currentSlide={currentSlide} handlePrev={handlePrev} />
          <NextButton
            currentSlide={currentSlide}
            planificationDatesLength={planificationDates.length}
            handleNext={handleNext}
          />
        </div>
      </Flex>
    </>
  );
};
